module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/3mill-inactive-d474a9eee6c250a7fb57a338c2cc19cd.png";